/**
 * Shared datetime formatting for the shift board + publish drawer (BON-240).
 *
 * BON-386 scope note: the shift/open-shift DTOs (`startsAtIso`, chip `date`)
 * carry only the absolute instant — no venue-local wall-clock field yet — so
 * these surfaces are OUT of the timezone-alignment slice and stay UTC-anchored,
 * unchanged, pending the follow-up that adds local fields to those DTOs. Kept
 * self-contained (not importing the now venue-local `workshopFields`
 * formatters) so that migration didn't silently change what the board renders.
 */

/** ISO instant → "Fri, Oct 1" (UTC). */
function formatShiftDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

/** ISO instant → "6:30p" clock label (UTC). */
function formatShiftTime(iso: string): string {
  const d = new Date(iso);
  const h = d.getUTCHours();
  const m = d.getUTCMinutes();
  const ampm = h >= 12 ? 'p' : 'a';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return m === 0 ? `${h12}${ampm}` : `${h12}:${String(m).padStart(2, '0')}${ampm}`;
}

export function formatShiftStart(iso: string): string {
  return `${formatShiftDate(iso)} · ${formatShiftTime(iso)}`;
}
